import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import Meta from 'vue-meta'
import VueI18n from 'vue-i18n'
import language from '@/language'
import '@/config/elementLazyLoad.js'
import ElementLocale from 'element-ui/lib/locale'
import '@/assets/css/element-variables.scss'
import { record } from '@/util/dataReport.js'
import '@/util/decorator.js'
import '@/filters/index.js'
// import animated from 'animate.css'
import _ from 'lodash'
import globalMixin from '@/mixin/globalMixin.js'
import '@/util/rem.js'
import '@/config/globalComponents.js'
import VueTouch from 'vue-touch'
import waterfall from 'vue-waterfall2'
// import Monitor from '@/util/Monitor.js'
// const monitor = new Monitor({
//   requestPath: 'http://127.0.0.1:3000/report'
// })

// prerender-spa-plugin预渲染配置title，description等
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

// Canvas绘图库
import { fabric } from 'fabric'
Vue.use(fabric)

Vue.use(waterfall)
// h5手指滑动事件
Vue.use(VueTouch, { name: 'v-touch' })
// 滚动条插件
import vuescroll from 'vuescroll'
Vue.use(vuescroll)
// vuescroll 默认配置
Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#CDD4DD'
  }
}
// Vue.use(animated)
Vue.use(VueI18n)
// Vue.use(Meta)
Vue.prototype.$record = record
Vue.mixin(globalMixin) // 全局mixin

const i18n = new VueI18n({
  locale: 'en',
  messages: language
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.config.productionTip = false
// Vue.config.errorHandler = (err, vm, info) => {
//   console.error(err)
//   monitor.vueErrorHandler(err, vm, info)
// }

/**
 * 点击事件添加节流
 */
const on = Vue.prototype.$on
Vue.prototype.$on = function(event, func) {
  if (event === 'click') {
    func = _.debounce(func, 500, { leading: true, trailing: false })
  }
  on.call(this, event, func)
}

/**
 * 判断data是否是一个非空数组
 * @param {any} data
 * @returns Boolean
 */
_.isNonEmptyArray = data => Array.isArray(data) && data.length > 0

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
